import { useEffect, useState } from "react";
import { fetchDriverQuery, submitDriverFeedback, getJobDrivers } from "./store/knownDataSlice";
import { useSearchParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { DataContainer } from "./components/DataContainer";
import TextareaAutosize from 'react-textarea-autosize';
import { toast } from "react-toastify";




function Feedback() {
    const [ searchParams ] = useSearchParams();
    const id = searchParams.get('id');
    const secret = searchParams.get('secret');
    // Per-driver links carry the driver's ID; legacy links use the job-level secret without it
    const driver = searchParams.get('driver');

    const dispatch = useDispatch();
    const data = useSelector((state) => state.knownData[id]);

    // State for driver selection and hours
    const [ availableDrivers, setAvailableDrivers ] = useState([]);
    const [ selectedDriverID, setSelectedDriverID ] = useState("");
    // Per-driver links lock the selection to the link's driver (backend enforces this too)
    const [ driverLocked, setDriverLocked ] = useState(false);
    const [ hoursArray, setHoursArray ] = useState(["0"]);
    const [ jobWentWell, setJobWentWell ] = useState(true);
    const [ jobFeedback, setJobFeedback ] = useState("");

    useEffect(() => {
        dispatch(fetchDriverQuery({ secret, id, driver }));

        // Fetch available drivers for this job
        dispatch(getJobDrivers({ id, secret, driver })).then(result => {
            if (result.payload && result.payload.drivers) {
                setAvailableDrivers(result.payload.drivers);
                // Pre-select the link's driver, falling back to the first (usually primary)
                const linkDriver = driver && result.payload.drivers.find(d => d.id.toUpperCase() === driver.toUpperCase());
                if (linkDriver) {
                    setSelectedDriverID(linkDriver.id);
                    setDriverLocked(true);
                } else if (result.payload.drivers.length > 0) {
                    setSelectedDriverID(result.payload.drivers[0].id);
                }
            }
        });
    }, [ id, secret, driver ]);

    async function onSave() {
        if (!selectedDriverID) {
            toast.error("Palun vali juht!");
            return;
        }

        await dispatch(submitDriverFeedback({
            __skipFetch: true,
            secret,
            id,
            driver,
            wentWell: jobWentWell,
            comment: jobFeedback,
            hours: JSON.stringify(hoursArray.map(str => parseFloat(str.trim() == "" ? "0" : str.trim().replace(",", ".")))),
            driverID: selectedDriverID
        }));
    }

    // Wait for both data and drivers to be loaded
    if(data === undefined || availableDrivers.length === 0) return;

    return (
        <DataContainer actionTypes={["knownData/submitDriverFeedback", "knownData/getJobDrivers"]}>
            <div className="width100 g32 p32 column center-main" style={{ height: '100vh', alignItems: 'stretch', maxWidth: 600, marginInline: 'auto' }}>
                    <h1>Hea juht!</h1>
                    <p>Tänud taas, et ABussi lippu kõrgel hoidsid. Palun sisesta reisile kulunud töötunnid.</p>

                    <div className="column g8">
                        <b>Kelle tunde sisestad</b>
                        {driverLocked ? (
                            <p>{(d => d ? `${d.firstname} ${d.lastname}` : "")(availableDrivers.find(d => d.id === selectedDriverID))}</p>
                        ) : (
                            <select
                                value={selectedDriverID}
                                onChange={(e) => setSelectedDriverID(e.target.value)}
                                style={{ padding: '8px', fontSize: '16px' }}
                            >
                                {availableDrivers.map(driver => (
                                    <option key={driver.id} value={driver.id}>
                                        {driver.firstname} {driver.lastname}
                                    </option>
                                ))}
                            </select>
                        )}
                    </div>

                    <div className="column center-cross">
                        <div className="column g8">
                            {hoursArray.map((val, index) => (
                                <div className="row g8 center-cross">
                                    <b>{index + 1}. päev:</b>
                                    <input
                                        key={index}
                                        style={{ width: '80px' }}
                                        type="text"
                                        value={val}
                                        onChange={(e) => {
                                            e.preventDefault();
                                            // If doesnt match pattern "(\d+[,.]\d?)|()" keep previous value
                                            if(!e.target.value.match(/^(\d+[,\.]?\d*)$|^$/)) return;

                                            const newHoursArray = [...hoursArray];
                                            newHoursArray[index] = e.target.value;
                                            setHoursArray(newHoursArray);
                                        }}
                                        onBlur={(e) => {
                                            // Strip trailing & leading zeros
                                            const newHoursArray = [...hoursArray];
                                            newHoursArray[index] = parseFloat(e.target.value.trim() == "" ? "0" : e.target.value.trim().replace(",", ".")).toString();
                                            setHoursArray(newHoursArray);
                                        }}
                                        onFocus={(e) => e.target.select()}
                                    />
                                    <p>tundi</p>
                                    {index > 0 ? (
                                        <button onClick={() => setHoursArray(hoursArray.filter((_, i) => i !== index))} style={{ backgroundColor: '#d4635b', borderColor: '#f4837b', color: '#fff' }}>×</button>
                                    ) : null}
                                </div>
                            ))}
                            <button onClick={() => setHoursArray([...hoursArray, "0"])}><b>+</b>&nbsp; Lisa päev</button>
                        </div>
                    </div>

                    <p>Kui arvad, et kõik ei laabunud päris nii nagu algselt plaanis oli, siis kirjuta sellest mõne sõnaga siin ja kohe, või vaiki igavesti!</p>


                    <div className="column g16">
                        <div className="row g16">
                            <input id="jobWentWell-true" type="radio" radioGroup='jobWentWell' value={true} onChange={() => setJobWentWell(true)} checked={jobWentWell} />
                            <label for="jobWentWell-true">Sõit läks plaanipäraselt</label>
                        </div>

                        <div className="row g16">
                            <input id="jobWentWell-false" type="radio" radioGroup='jobWentWell' value={false} onChange={() => setJobWentWell(false)} checked={!jobWentWell} />
                            <label for="jobWentWell-false">Sõit ei läinud plaanipäraselt</label>
                        </div>
                    </div>

                    <div className="column g4">
                        <TextareaAutosize spellCheck={false} minRows="3" style={{ resize: 'none', fontFamily: 'unset' }} placeholder='Täpsusta kui vaja' value={jobFeedback} onChange={(e) => setJobFeedback(e.target.value)} />
                        <i style={{ color: '#888', fontSize: 14 }}>Vajuta Enter-it, et uuele reale minna</i>
                    </div>

                    <button onClick={onSave}>Salvesta</button>
                </div>
        </DataContainer>
    );
}

export default Feedback;